export const MAX_CASH_PAYMENT_AMOUNT = 199999;

export const CASH_PAYMENT_MAX_ERROR =
  "Cash payment cannot exceed ₹1,99,999 per patient";

export const isCashPaymentMode = (mode) => mode === "cash";

export const validateCashPaymentAmount = (amount, mode) => {
  if (!isCashPaymentMode(mode)) return null;
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) return null;
  if (numericAmount > MAX_CASH_PAYMENT_AMOUNT) return CASH_PAYMENT_MAX_ERROR;
  return null;
};

export const createCashAmountRule = (form, modePath = "mode") => ({
  validator: (_, value) => {
    const mode = form.getFieldValue(modePath);
    const error = validateCashPaymentAmount(value, mode);
    return error ? Promise.reject(new Error(error)) : Promise.resolve();
  },
});


export const syncCashAmountValidation = (form, mode, amountPath = "amount") => {
  if (!mode) return;

  if (isCashPaymentMode(mode)) {
    form.validateFields([amountPath]).catch(() => {});
  } else {
    form.setFields([{ name: amountPath, errors: [] }]);
    form.validateFields([amountPath]).catch(() => {});
  }
};
